<template>

	<section v-if="statusModal">

		<div class="back_lay" @click="closeModal"></div>

		<!-- Modal -->
		<div class="modal_shadow statusModal">
                <ul class="drop-menu" v-show="true" :style="{'top': posY + 'px', 'left': posX + 'px'}">
                    <li class="drop-menu__item">
                        <div style="background: #f1f1f1" class="title">
                            Сменить статус визита
                        </div>
                    </li>
                    <li class="drop-menu__item">
                        <div @click="changeStatus(newStatus = 'not_confirmed')" class="drop-menu__link" :style="{'background': config.not_confirmed}">
                            Не подтвержден
                        </div>
                    </li>
                    <li class="drop-menu__item">
                        <div @click="changeStatus(newStatus = 'confirmed')" class="drop-menu__link" :style="{'background': config.confirmed}">
                            Подтвержден
                        </div>
                    </li>
                    <li class="drop-menu__item">
                        <div @click="changeStatus(newStatus = 'came')" class="drop-menu__link" :style="{'background': config.came}">
                            Идет прием
                        </div>
                    </li>
                    <li class="drop-menu__item">
                        <div @click="changeStatus(newStatus = 'completed')" class="drop-menu__link" :style="{'background': config.completed}">
                            Завершен
                        </div>
                    </li>
                    <li class="drop-menu__item">
                        <div @click="changeStatus(newStatus = 'not_appeared')" class="drop-menu__link" :style="{'background': config.not_appeared}">
                            Неявка
                        </div>
                    </li>
                </ul>
            </div>
<!--            <i class="modal__icon_close icon ion-close trans" @click="closeModal"></i>-->
		<!-- Modal End -->
	</section>

</template>

<script>
	export default {
		name: 'StatusModal',
		computed: {
			isRegistry() {
				if (this.$route.path === '/registry')
					return true
			},
			doctorId() {
				if (this.$route.query.doctor)
					return this.$route.query.doctor
			},
			workerId() {
				return this.$store.state.auth.worker._id
			},
			doctorRoles() {
				return this.$store.state.auth.worker.role
			},
			client() {
				return this.visit.users[0]
			},
			isMyVisit() {
				return this.visit.workers[0]._id === this.workerId
			}
		},
		mounted() {
			this.$event.connect('openStatusModal', (model, forCancel) => {
				this.visit = model.event
				this.statusModal = true
				this.isCancel = forCancel || false
                this.posX = this.correctPositionX(model.posX)
                this.posY = this.correctPositionY(model.posY)
			})

			this.$event.connect('closeStatusModal', () => {
				this.closeModal()
			})
		},
		beforeDestroy() {
			this.$event.disconnect(['openStatusModal', 'closeStatusModal'])
		},
		data() {
			return {
				statusModal: false,
				isCancel: false,
				visit: {},
				reason: '',
                posX: '',
                posY: '',
                config: {
					not_confirmed: '#68cae0',
					confirmed: '#06a6c9',
					came: '#f3a50a',
					completed: '#28db74',
					canceled: '#999999',
					not_appeared: '#eb774a',
				},
                newStatus: '',
			}
		},
		methods: {
			showClinic(id) {
				this.closeModal()

				this.$router.push({
					path: 'Clinic',
					query: {
						clinic: id
					}
				})
			},
			closeModal() {
				this.visit = {}
				this.statusModal = false
				this.isCancel = false
				this.reason = ''
			},
			whenState(status, arr) {
				return arr.indexOf(status) !== -1
			},
            correctPositionX(posX){
                if ((posX + 180) > document.documentElement.clientWidth) {
                    return posX - 180;
                }
                return posX;
            },            
            correctPositionY(posY){
                if ((posY + 210) > document.documentElement.clientHeight) {
                    return posY - 210;
                }
                return posY;
            },
            changeStatus(newStatus) {
                console.log(this.visit);
                this.visit.status = this.newStatus;
                this.$store.dispatch('agenda/update', {
					id: this.visit._id,
					status: this.newStatus
				}).then(() => {
					this.closeModal()
				})
            }
		}
	}
</script>


// WEBPACK FOOTER //
// StatusModal.vue?a83fdc02